<template>
    <div class="movie_list">
        <div
            class="movie_list_item"
            v-for="(movieItem, index) in movieItems"
            :key="index"
        >
            <new-movie-card :item="movieItem" />
        </div>
        <template v-if="isLoading">
            <div class="movie_list_item" v-for="item in cardCount" :key="item">
                <new-movie-card :loader="true" />
            </div>
        </template>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import NewMovieCard from "./NewMovieCard.vue";

export default {
    name: "MovieList",

    components: {
        NewMovieCard,
    },

    computed: mapGetters(["checkAccess", "getWorld"]),

    props: {
        movieItems: {
            type: Array,
        },
        isLoading: {
            type: Boolean,
        },
        cardCount: {
            type: Number,
        },
    },

    mounted() {
        // window.scrollTo({
        //     top: 0,
        //     behavior: "auto",
        // });
    },
};
</script>
<style scoped lang="scss">
@mixin itemColumnWidth($item, $gap) {
    width: calc(100% / $item - (($item - 1) * $gap) / $item);
}
.movie_list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
    &_item {
        @include itemColumnWidth(9, 12px);
    }
}

@media screen and (max-width: 1920px) {
    .movie_list {
        gap: 8px;
        &_item {
            @include itemColumnWidth(6, 8px);
        }
    }
}

@media screen and (max-width: 1440px) {
    .movie_list {
        gap: 8px;
        &_item {
            @include itemColumnWidth(5, 8px);
        }
    }
}

@media screen and (max-width: 1024px) {
    .movie_list {
        gap: 8px;
        &_item {
            @include itemColumnWidth(4, 8px);
        }
    }
}

@media screen and (max-width: 992px) {
    .movie_list {
        gap: 8px;
        &_item {
            @include itemColumnWidth(3, 8px);
        }
    }
}

@media screen and (max-width: 576px) {
    .movie_list {
        gap: 8px;
        &_item {
            @include itemColumnWidth(2, 8px);
        }
    }
}
</style>
